export default {"src":"/_next/static/media/loreal.d7ce9c2d.svg","height":62,"width":176,"blurWidth":0,"blurHeight":0};